import React, { useState } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
//import logo from "./logo_clean_verify.png"
import "../../../App.css";




//import AuthVerify from "./common/AuthVerify";
//import EventBus from "./common/EventBus";

const AlertBox = ({message, type = 'info'}) => {

  const [isVisible,setIsVisible] = useState(true);
  
  const CloseButton = () => {

    

    function handleClick (){
    
      console.log("toggle visibility: "+!isVisible)
      setIsVisible(!isVisible);
      
    
    }
  
    return (     


      <button  
              type="button"
              className={
                `                  
                  p-1.5 
                  text-zinc-700
                  
                `
              } 
              
              onClick={handleClick}
              >
        
        <span className="font-semibold text-neutral-400 hover:text-white">🗙</span>
          
      </button>

    );
  } 

  console.log(type);
  console.log(message);

if(type === 'info' && isVisible){

  return (
    
    <div className={isVisible ? (``) : (` hidden`) }>
      <div className={`alert  alert-info`} 
        role="alert">
          <div className={`flex flex-row justify-between`}>
            <p>
              <strong className="text-sx font-semibold text-sky-700">Nota:</strong><br/>
              <span className="text-xs"> {message}</span> 
            </p>
            
            <CloseButton />
          </div>
      </div>
    </div>
      
   
  );

}

if(type === 'success' && isVisible){

  return (
    
    <div className={``+isVisible ? (``) : (` hidden`) }>
      <div className={`alert  alert-success`} 
        role="alert">
          <div className={`flex flex-row justify-between`}>
            <p>
              <strong className="text-sx font-semibold text-lime-700">Éxito:</strong><br/>
              <span className="text-xs"> {message}</span> 
            </p>
            
            <CloseButton />
          </div>
      </div>
    </div>
      
   
  );

}

if(type === 'error' && isVisible){

  return (
    
    <div className={``+ isVisible ? (``) : (` hidden`) }>
      <div className={`alert alert-danger`} 
        role="alert">
          <div className={`flex flex-row justify-between`}>
            <p>
              <strong className="text-sx font-semibold text-red-700">Error:</strong><br/>
              <span className="text-xs" >{message}</span> 
            </p>
            
            <CloseButton />
          </div>
      </div>
    </div>
      
   
  );

}

if(type === 'warning' && isVisible){

  return (
    
    <div className={``+ isVisible ? (``) : (` hidden`) }>
      <div className={`alert alert-warning`} 
        role="alert">
          <div className={`flex flex-row justify-between`}>
            <p>
              <strong className="text-sx font-semibold text-yellow-500">Advertencia:</strong><br/>
              <span className="text-xs" >{message}</span> 
            </p>
            
            <CloseButton />
          </div>
      </div>
    </div>
      
   
  );

}
  
};

export default AlertBox;
